import { TFunction } from "next-i18next";

import { ContactTypes } from "constants/enum";
import contacts from "configs/contacts";
import { PageContentProps } from "content/content.types";

const pageContent = (t: TFunction, { locale }: PageContentProps) => [
    {
        link: `tel:${contacts.phone[locale].link}`,
        icon: ContactTypes.PHONE,
        title: contacts.phone[locale].link,
    },
    {
        link: contacts.email[locale].link,
        icon: ContactTypes.EMAIL,
        title: t("global:email"),
    },
];

export default pageContent;
